var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.167 2V7.00002L12.167 7.05442V7.05443V7.05445V7.05446C12.1669 7.47852 12.1668 7.89063 12.2125 8.23053C12.264 8.61374 12.3896 9.05101 12.7528 9.41423C13.116 9.77744 13.5533 9.90297 13.9365 9.95449C14.2764 10.0002 14.6885 10.0001 15.1125 10H15.1126H15.1126H15.1126L15.167 10H20V16C20 18.8284 20 20.2426 19.1213 21.1213C18.2426 22 16.8284 22 14 22H10C7.17157 22 5.75736 22 4.87868 21.1213C4 20.2426 4 18.8284 4 16V8C4 5.17157 4 3.75736 4.87868 2.87868C5.75736 2 7.17157 2 10 2H12.167ZM14.167 2.01045V7.00002C14.167 7.49969 14.1691 7.77385 14.1947 7.96404L14.1957 7.97132L14.203 7.97232C14.3932 7.99789 14.6673 8.00002 15.167 8.00002H19.9954C19.9852 7.58836 19.9525 7.31596 19.8478 7.06306C19.6955 6.69552 19.4065 6.40649 18.8284 5.82843L16.1716 3.17157C15.5935 2.59351 15.3045 2.30448 14.9369 2.15224C14.7199 2.06234 14.4885 2.02552 14.167 2.01045ZM7.5 13C7.5 12.4477 7.94772 12 8.5 12L15.5 12C16.0523 12 16.5 12.4477 16.5 13C16.5 13.5523 16.0523 14 15.5 14L8.5 14C7.94772 14 7.5 13.5523 7.5 13ZM8.5 16C7.94772 16 7.5 16.4477 7.5 17C7.5 17.5523 7.94772 18 8.5 18H13.1667C13.719 18 14.1667 17.5523 14.1667 17C14.1667 16.4477 13.719 16 13.1667 16H8.5Z",
    fill: "#FF4F64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentLarge);
export default __webpack_public_path__ + "static/media/ic_document_large.6195b33eeb6350b650e2ee91dbfd53c3.svg";
export { ForwardRef as ReactComponent };